import {assertIsNotNullish} from '@br/idm-components';

export const getCsrfToken = (): string => {
    const token = document.querySelector<HTMLInputElement>('[name=csrfmiddlewaretoken]')?.value;
    assertIsNotNullish(token);
    return token;
};
